import { Box, Card, CardHeader, Grid, Typography } from '@mui/material'
import React from 'react'
import NotificationList from './NotificationList'

const SupervisorNotificationList = () => {
  return (
    <Grid container spacing={2}>
  <Grid item xs={12}>
    <Card>
      <CardHeader
        title={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Notifications</Typography>
          </Box>
        }
      />
      <NotificationList />
    </Card>
  </Grid>
</Grid>

  )
}

export default SupervisorNotificationList